import { render, staticRenderFns } from "./planD.vue?vue&type=template&id=04fcb5b4&scoped=true&"
import script from "./planD.vue?vue&type=script&lang=js&"
export * from "./planD.vue?vue&type=script&lang=js&"
import style0 from "./planD.vue?vue&type=style&index=0&id=04fcb5b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fcb5b4",
  null
  
)

export default component.exports